/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Operationhours1Inputs */



/**
* | output |
* | --- |
* | "Operating hours" |
*
* @param {Ahu_History_Key_Operationhours1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_operationhours1 = /** @type {((inputs?: Ahu_History_Key_Operationhours1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Operationhours1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operating hours")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement")
});
export { ahu_history_key_operationhours1 as "ahu_history_key_operationHours" }